<template>
  <div class="main">
    <AllHeader title="理事会"></AllHeader>
    <div class="wrapper">
      <div class="allBox">
        <div
          :style="(index+1)%3==0?'margin-right:0':''"
          class="showBox"
          v-for="(item,index) in lszData"
          :key="index"
        >
          <img :src="item.picture" alt />
          <h3>{{item.fee}} : {{item.title}}</h3>
        </div>
      </div>
      <div v-if="flszData.length>0" class="bline"></div>
      <div class="allBox">
        <div
          :style="(index+1)%3==0?'margin-right:0':''"
          class="showBox"
          v-for="(item,index) in flszData"
          :key="index"
        >
          <img :src="item.picture" alt />
          <h3>{{item.fee}} : {{item.title}}</h3>
        </div>
      </div>
      <div v-if="jsData.length>0" class="bline"></div>
      <div class="allBox">
        <div
          :style="(index+1)%3==0?'margin-right:0':''"
          class="showBox"
          v-for="(item,index) in jsData"
          :key="index"
        >
          <img v-if="item.picture" :src="item.picture" alt />
          <h3>{{item.fee}} : {{item.title}}</h3>
        </div>
      </div>
      <div class="bline"></div>
      <div v-if="lsData.length>0" class="allBox">
        <div
          :style="(index+1)%3==0?'margin-right:0':''"
          class="showBox"
          v-for="(item,index) in lsData"
          :key="index"
        >
          <img v-if="item.picture" :src="item.picture" alt />
          <h3>{{item.fee}} : {{item.title}}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import { getLsh } from "@/api/gywm.js";
import { BASE_URL } from "@/utils/base.js";
export default {
  data() {
    return {
      lszData: [],
      lsData: [],
      jsData:[],
      flszData:[],

    };
  },
  mounted() {
    // window.scrollTo(0, 0);
    this.getData()
  },
  methods: {
    async getData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 100);
      let note = await getLsh(news);
      note.rows.forEach(ele => {
        if(ele.picture){
        ele.picture=BASE_URL+ele.picture;
        }
        if (ele.fee == "理事长") {
          this.lszData.push(ele);
        } else if (ele.fee == "理事"){
          this.lsData.push(ele);
        } else if (ele.fee == "副理事长"){
          this.flszData.push(ele);
        } else if (ele.fee == "监事"){
          this.jsData.push(ele);
        }
      });
    }
  },
  components: {
    AllHeader
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 10px;
  width: 100%;
  .wrapper {
    width: 95%;
    margin: 40px auto;
    color: #000;
    .bline {
      width: 100%;
      height: 2px;
      background-color: #f0f0f0;
    }
    .allBox {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;

      .showBox {
        width: 160px;
        margin-right: 40px;
        img {
          width: 160px;
          height: 160px;
        }
        h3 {
          width: 160px;
          text-align: center;
          font-size: 16px;
          line-height: 1.2;
          margin: 20px 0 30px;
        }
      }
    }
  }
}
</style>